import { create } from 'zustand';

interface KubeezGenerateDialogState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useKubeezGenerateDialogStore = create<KubeezGenerateDialogState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
